import { markRaw, ref } from 'vue';
import { defineStore } from 'pinia';

export const useModalStore = defineStore('modalStore', () => {
  const title = ref('');
  const isOpen = ref(false);
  const component = ref(null);
  const actions = ref([]);
  const style = ref({});
  const props = ref({});
  const modelValue = ref({});
  const onClose = ref(null);

  const open = (options) => {
    title.value = options.title;
    isOpen.value = true;
    actions.value = options.actions ? options.actions : [];
    component.value = markRaw(options.component);
    props.value = options.props;
    style.value = options.style;
    modelValue.value = options.modelValue;
    onClose.value = options.onClose;
  };

  const close = () => {
    try {
      actions.value.filter((a) => a.event === 'close').forEach((a) => a.callback());
    } catch (err) {
      console.error(err);
    }

    isOpen.value = false;
    component.value = {};
    actions.value = [];
    modelValue.value = {};
  };

  return {
    title,
    isOpen,
    component,
    actions,
    style,
    props,
    modelValue,

    open,
    close
  };
});
